export class LanguageInputsSwitcher
{

    /**
     * @todo: Refactor so it works with dynamically added elements.
     */
    constructor() {
        LanguageInputsSwitcher.initListeners();
    }

    static initListeners()
    {
        const formTabGroup = document.getElementsByClassName('form-group__top-tab');

        for(let i = 0; i < formTabGroup.length; i++) {

            formTabGroup[i].addEventListener('click', () => {
                if(formTabGroup[i] !== undefined) {
                    let currentTabAtrr = formTabGroup[i].getAttribute('data-language-control');
                    let currentTabClass = document.querySelectorAll(`[data-language-control= ${currentTabAtrr}]`);

                    toggleActiveTab(i, currentTabClass);
                    toggleActiveInput(i, currentTabAtrr);
                }

            })
        }

        const toggleActiveTab = (i, currentTabClass) => {
            let activeTabs = document.querySelectorAll('.--active-tab');
            [].forEach.call(activeTabs, function(el) {
                el.classList.remove("--active-tab");
            });

            [].forEach.call(currentTabClass, function(el) {
                el.classList.add("--active-tab");
            });
        };

        const toggleActiveInput = (i, currentTabAtrr) => {

            let activeInput = document.querySelectorAll('.--show-input');
            [].forEach.call(activeInput, function(el) {
                el.classList.remove("--show-input");
            });

            let currentInputClass = document.querySelectorAll(`[data-language= ${currentTabAtrr}]`);
            [].forEach.call(currentInputClass, function(el) {
                el.classList.add("--show-input");
            });

        };
    }

}

/**
 * Collect translated values for inputs having given class
 *
 * @param className
 * @return {{}}
 */
export const collectTranslatedValues = (className) => {
    let values = {};

    $(className).each(function(){
        const $this = $(this);
        const lang = $this.attr('data-language');
        values[lang] = $this.val();
    });

    console.log(values);
    return values;
};

export const collectTranslatedCoreServiceDatas = (className,fieldname) => {
    let data = [];  
    
    $(className).each(function() {
        let values = {};
        const $this = $(this);
        const lang = $this.attr('data-language');
        values['language_code'] = lang;
        values[fieldname] = $this.val();
        data.push(values);
    });
    console.log(data);
    return data;
};


/**
 * Get translated names
 * @return Object
 */
export const getNames = () => {
    return collectTranslatedValues('.form-field__name');
};

/**
 * Gte translated descriptions
 *
 * @return {{}}
 */
export const getDescriptions = () => {
    return collectTranslatedValues('.form-field__description');
};


export const getFullDescriptions = () => {
    return collectTranslatedValues('.form-field__full_description');
};